import { UploadFile } from 'antd';

export function appendDossierFormDataDocuments(
  files: UploadFile[],
  formData: FormData,
  prefix: string[],
) {
  files
    .filter(({ url }: UploadFile) => !url) // Ignorer les fichiers déjà uploadés
    .forEach((file: UploadFile) => {
      // Comme il n'est pas possible de donner des noms de champs dynamiques pour les fichiers,
      // on concatène le type et le sous-type de fichier au nom de fichier en utilisant des ***
      // (qui sont des caractères inutilisables en temps normal dans un nom de fichier)
      const newName = [...prefix, file.name].join(' *** ');

      const realFile = file as unknown as File;

      // fallback MIME type
      const fileType = file.type || 'application/octet-stream';

      // Créée un clone du fichier avec le nouveau nom
      const newFile = new File([realFile], newName, {
        type: fileType,
      });

      // Ajoute le fichier au données du formulaire
      formData.append('documents', newFile);
    });
}
